import BannerComp from "../components/BannerComp";
import FaqsComp from "../components/FaqsComp";
import Seo from "../components/Seo";
import { answers, questions } from "../data/faqs-data";
import { createBreadcrumbSchema } from "../lib/seo";
import styles from "./Faqs.module.css";

const leftColumnQuestions = questions.slice(0, 5);
const leftColumnAnswers = answers.slice(0, 5);
const rightColumnQuestions = questions.slice(5);
const rightColumnAnswers = answers.slice(5);
const stripHtml = (value = "") => value.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
const seo = {
  title: "Helpful answers for providers evaluating billing | PSP RCM",
  description:
    "Get answers to questions about PSP's medical billing, revenue cycle management, AR recovery, credentialing, and more.",
  keywords: "medical billing faq, revenue cycle faq, PSP RCM questions",
  schema: [
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      name: "Helpful answers for providers evaluating billing",
      url: "https://psprcm.us/faqs/",
      description:
        "Get answers to questions about PSP's medical billing, revenue cycle management, AR recovery, credentialing, and more.",
      mainEntity: questions.map((question, index) => ({
        "@type": "Question",
        name: question.replace(/^\d+\.\s*/, ""),
        acceptedAnswer: {
          "@type": "Answer",
          text: stripHtml(answers[index]),
        },
      })),
    },
    createBreadcrumbSchema("/faqs", "Helpful answers for providers evaluating billing"),
  ],
};

export default function Faqs() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalPath="/faqs"
        schema={seo.schema}
      />
      <BannerComp
        heading="Your Guide to PSP RCM - FAQ's"
        paragraph="Have questions about medical billing and revenue cycle management? We have answers! Learn how PSP RCM streamlines billing, boosts revenue, and optimizes practice efficiency."
        form
      />

      <section className={styles.section}>
        <div className={`container ${styles.intro}`}>
          <span className={styles.eyebrow}>PSP - Your Questions Answered</span>
          <h2>
            Helpful answers for providers evaluating billing and operational
            support.
          </h2>
          <p>
            Get answers to questions about PSP's medical billing, revenue cycle
            management, AR recovery, credentialing, and more. Learn how our
            expertise helps healthcare providers maximize revenue and ease
            operations.
          </p>
        </div>

        <div className={`container ${styles.faqGrid}`}>
          <div className={styles.column}>
            <FaqsComp
              question={leftColumnQuestions}
              answer={leftColumnAnswers}
            />
          </div>
          <div className={styles.column}>
            <FaqsComp
              question={rightColumnQuestions}
              answer={rightColumnAnswers}
            />
          </div>
        </div>
      </section>
    </>
  );
}
